export const businessVerification = {
  pageView: () => ({
    event_name: 'page_view',
    page_name: 'vodapay: business advance: opf: business details: personal details: business type: information',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website'
  }),

  formStart: () => ({
    event_name: 'form_start',
    page_name: 'vodapay: business : opf: business details :business verification',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    form_name: 'business : opf: business verification'
  }),

  formEnd: () => ({
    event_name: 'ui_interaction, form_end',
    page_name: 'vodapay: business advance: opf: business details: personal details: business type: information',
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    form_name: 'business : opf: business verification',
    link_name: 'vodapay: business advance: opf: business details: personal details: business type: information: next'
  })
};